import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const styles = {
  cardBody: {
    display: 'flex',
    alignItems: 'flex-start',
  },

  cardHeader: {
    width: '40%',
    textAlign: 'start',
  },

  dateContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '25%',
  },

  description: {
    fontSize: '15px',
    fontFamily: 'Nunito , sans-serif',
    fontWeight: 'bold',
  },

  date: {
    fontSize: '12px',
    color: 'gray',
    fontFamily: 'Nunito , sans-serif',
  },
  rejectContainer: {
    width: '70%',
    border: '1px solid #FFA500',
    borderRadius: '10px',
    padding: '5px',
    backgroundColor: '#e9e9e9',
  },
  rejectTitle: {
    fontSize: '16px',
    fontFamily: 'Nunito , sans-serif',
    fontWeight: 'bold',
  },
  rejectDescription: {
    fontSize: '14px',
    fontFamily: 'Nunito , sans-serif',
  },
  radioGroup: {
    flexWrap: 'nowrap',
    '& :nth-child(5)': {
      order: '-2',
    },
    '& :nth-child(1)': {
      order: '-1',
    },
    '& :nth-child(7)': {
      order: '-1',
    },
  },
};

export const Button = styled.button`
  width: 150px;
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 50px;
  letter-spacing: 1px;
  margin: 0 ;
  &:hover {
    background-color: #FFA555;
    border-color: #fff;
  }
}
`;
export const Description = styled(Typography)`
  &.MuiTypography-root {
    font-weight: bold;
    font-size: 14px;
    font-family: Nunito, sans-serif;
    width: 75%;
  }
`;

export const useStyles = makeStyles(styles);
